import { Component, Input } from '@angular/core';

@Component({
  selector: 'opac-user-title',
  templateUrl: './user-title.component.html',
  styleUrls: ['./user-title.component.scss']
})
export class UserTitleComponent {
  /**
   * Sets the title of the section.
   */
  @Input() title: string = '';
  /**
   * Determines if the title should be displayed as a skeleton.
   */
  @Input() skeleton: boolean = false;
}
